import { getLoginData } from '@ami/react/core';
import { appConfig } from '@ami/react/core';

function isAmiUserAuthorized(permission) {
  if (!appConfig.isManagementApp) return false;
  const loginData = getLoginData();
  if (!loginData) return false;

  return loginData.userData.permissions && loginData.userData.permissions.includes(permission);
}

export function isAmiUserAuthorizedToViewQuotes() {
  return isAmiUserAuthorized('ViewQuotes');
}

export function isAmiUserCanEditPaintColor() {
  return isAmiUserAuthorizedToCreateQuotes() || isAmiUserAuthorizedToManageQuotes();
}

export function isAmiUserAuthorizedToCreateQuotes() {
  return isAmiUserAuthorized('CreateQuotes');
}

export function isAmiUserAuthorizedToAcceptQuotes() {
  return isAmiUserAuthorized('AcceptQuotes');
}

export function isAmiUserAuthorizedToManageQuotes() {
  return isAmiUserAuthorized('ManageQuotes');
}

export function isAmiUserAuthorizedToManageQuoteDocuments() {
  return isAmiUserAuthorized('ManageQuoteDocuments');
}

export function isAmiUserAuthorizedToViewOrders() {
  return isAmiUserAuthorized('ViewOrders');
}

export function isAmiUserAuthorizedToCreateOrders() {
  return isAmiUserAuthorized('CreateOrders');
}

export function isAmiUserAuthorizedToManageOrders() {
  return isAmiUserAuthorized('ManageOrders');
}

export function isAmiUserAuthorizedToManageOrderDocuments() {
  return isAmiUserAuthorized('ManageOrderDocuments');
}

export function isAmiUserAuthorizedToManageOrderShipping() {
  return isAmiUserAuthorized('ManageOrderShipping');
}

export function isAmiUserAuthorizedToViewDealers() {
  return isAmiUserAuthorized('ViewDealers');
}

export function isAmiUserAuthorizedToManageDealers() {
  return isAmiUserAuthorized('ManageDealers');
}

export function isAmiUserAuthorizedToManageDealerUsers() {
  return isAmiUserAuthorized('ManageDealerUsers');
}

export function isAmiUserAuthorizedToManageProducts() {
  return isAmiUserAuthorized('ManageProducts');
}

export function isAmiUserAuthorizedToManageAnnouncements() {
  return isAmiUserAuthorized('ManageAnnouncements');
}

export function isAmiUserAuthorizedToManageFreightCarriers() {
  return isAmiUserAuthorized('ManageFreightCarriers');
}

export function isAmiUserAuthorizedToManageSharedDocuments() {
  return isAmiUserAuthorized('ManageSharedDocuments');
}

export function isAmiUserAuthorizedToManagePriceZones() {
  return isAmiUserAuthorized('ManagePriceZones');
}

export function isAmiUserAuthorizedToManagePricing() {
  return isAmiUserAuthorized('ManagePricing');
}

export function isAmiUserAuthorizedToManageMachines() {
  return isAmiUserAuthorized('ManageMachines');
}

export function isAmiUserAuthorizedToManageInventory() {
  return isAmiUserAuthorized('ManageInventory');
}

export function isAmiUserAuthorizedToManageInstallation() {
  return isAmiUserAuthorized('ManageInstallation');
}

export function isAmiUserAuthorizedToManageLeadTimes() {
  return isAmiUserAuthorized('ManageLeadTimes');
}

export function isAmiUserAuthorizedToManageAmiUsers() {
  return isAmiUserAuthorized('ManageAMIUsers');
}

export function isAmiUserAuthorizedToManageAmiTeams() {
  return isAmiUserAuthorized('ManageAMITeams');
}

export function isAmiUserAuthorizedToManageCurrencies() {
  return isAmiUserAuthorized('ManageCurrencies');
}

export function isAmiUserAuthorizedToManageCouplerStyles() {
  return isAmiUserAuthorized('ManageCouplerStyles');
}

export function isAmiUserAuthorizedToManageNotifications() {
  return isAmiUserAuthorized('ManageNotifications');
}

export function isAmiUserAuthorizedToManageShippingCategories() {
  return isAmiUserAuthorized('ManageShippingCategories');
}

export function isAmiUserAuthorizedToSendBulkInvitations() {
  return isAmiUserAuthorized('SendBulkInvitations');
}

export function isAmiUserAuthorizedToManageHolidays() {
  return isAmiUserAuthorized('ManageHolidays');
}



export function isAmiUserGlobalAdministrator() {
  return isAmiUserAuthorized('GlobalAdministrator');
}

export function isAmiUserAuthorizedToManageQuoteNotificationRule() {
  return isAmiUserAuthorized('ManageQuoteNotificationRules');
}

export function isAmiUserAuthorizedToViewInventory() {
  return isAmiUserAuthorized('ViewInventory');
}

export function isAmiUserAuthorizedToManageTaskTypes() {
  return isAmiUserAuthorized('ManageTaskTypes');
}

export function isAmiUserAuthorizedToQuotePdfwithNoLeadTimes() {
  return isAmiUserAuthorized('QuotePdfWithNoLeadTimes');
}

export function isAmiUserAuthorizedToCustomerApprovalEngineering() {
  return isAmiUserAuthorized('CustomerApprovalEngineering');
}
export function isAmiUserAuthorizedToManageCustomerApprovals() {
  return isAmiUserAuthorized('ManageCustomerApprovals');
}
export function isAmiUserAuthorizedToManageQuoteGroups() {
  return isAmiUserAuthorized('ManageQuoteGroups');
}
export function isAmiUserAuthorizedToViewQuoteGroups() {
  return isAmiUserAuthorized('ViewQuoteGroups');
}
export function isAmiUserAuthorizedToManageOrderGroups() {
  return isAmiUserAuthorized('ManageOrderGroups');
}
export function isAmiUserAuthorizedToViewOrderGroups() {
  return isAmiUserAuthorized('ViewOrderGroups');
}
export function isAmiUserAuthorizedToManageTasks() {
  return isAmiUserAuthorized('ManageTasks');
}
export function isAmiUserAuthorizedToManagePinKits() {
  return isAmiUserAuthorized('ManagePinKits');
}
export function isAmiUserAuthorizedToManageThumbClasses() {
  return isAmiUserAuthorized('ManageThumbClasses');
}
export function isAmiUserAuthorizedToManageMachinePinUps() {
  return isAmiUserAuthorized('ManageMachinePinUps');
}
export function isAmiUserAuthorizedToManageShimKits() {
  return isAmiUserAuthorized('ManageShimKits');
}
export function isAmiUserAuthorizedToManageIndustries() {
  return isAmiUserAuthorized('ManageIndustries');
}
export function isAmiUserAuthorizedToManageDiscounts() {
  return isAmiUserAuthorized('ManageDiscounts');
}
export function isAmiUserAuthorizedToViewDiscounts() {
  return isAmiUserAuthorized('ManageDiscounts') || isAmiUserAuthorized('ViewDiscounts');
}

export function isAmiUserAuthorizedToOverrideQuoteLeadTimes() {
  return isAmiUserAuthorized('OverrideQuoteLeadTimes');
}
